import ExamPreparationBanner from "../../Components/ExamPreparationBanner";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import PracticePaperComp from "../../Components/ExamPreparationCards/PracticePaperComp";
import HotCoursesHelp from "../../Components/ExamPreparationCards/HotCoursesHelp";
import FamousUniversity from "../../Components/ExamPreparationCards/FamousUniversity";
import StudyNotes from "../../Components/ExamPreparationCards/StudyNotes";
import QuestionBank from "../../Components/ExamPreparationCards/QuestionBankComp";
import Certificate from "../../Components/ExamPreparationCards/Certificate";
import Formatting from "../../Components/ExamPreparationCards/Formatting";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const ExamPreparation = () => {
  // const { categoryId } = useContext(CategoryContext);

   const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Exam Preparation", }
  ]
  return (
    <>
      <Helmet>
        <title>Ace Your Exams with the Best Study Resources</title>
        <meta
          name="description"
          content="Prepare effectively for your exams with class notes, textbook summaries, and expert insights from fellow students. Focus on what matters and grasp key concepts quickly for better results!"
        />
        <meta property="og:title" content="Exam Preparation Page - DoubtQ" />
        <meta
          property="og:description"
          content="Prepare effectively for your exams with class notes, textbook summaries, and expert insights from fellow students. Focus on what matters and grasp key concepts quickly for better results!"
        />
      </Helmet>

      <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <ExamPreparationBanner />
      <SiteReviews />
      <StudyNotes />
      <PracticePaperComp />
      <QuestionBank />
      <HotCoursesHelp />
      <FamousUniversity />
      <Certificate />
      <Formatting />
      <ScrollTop />
    </>
  );
};

export default ExamPreparation;
